import React from 'react'
import { useTranslation } from 'react-i18next'
import { getIdElement } from '../../util/StringUtil'
import { CisLink, TreeLink } from '../app/Links'

export default function OwnerId({ ownerInfo }) {
  const { t } = useTranslation()
  let ownerIdResult

  // Needs to handle ownerGroupId where ownerCisId will not be set
  if (!ownerInfo) {
    ownerIdResult = t('none', 'None')
  } else if (ownerInfo.ownerName === 'Public') {
    ownerIdResult = t('public', 'Public')
  } else if (ownerInfo.ownerCisId && ownerInfo.ownerCisId.startsWith('cis.wkca.')) {
    ownerIdResult = <span>{t('admin', 'Admin')}</span>
  } else if (!ownerInfo.ownerCisId && !ownerInfo.ownerTreeId) {
    ownerIdResult = null
  } else {
    let cisIdText
    if (ownerInfo.ownerCisId && ownerInfo.ownerName) {
      cisIdText = `${getIdElement(ownerInfo.ownerCisId)} (${ownerInfo.ownerName})`
    } else if (ownerInfo.ownerCisId) {
      cisIdText = getIdElement(ownerInfo.ownerCisId)
    }
    ownerIdResult = (
      <>
        {ownerInfo.ownerCisId && (
          <>
            {`${t('cisId', 'CIS ID')}: `}
            <CisLink text={cisIdText} userId={getIdElement(ownerInfo.ownerCisId)} />
          </>
        )}
        {ownerInfo.ownerTreeId && (
          <>
            {`${t('treeId', 'Tree ID')}: `}
            <TreeLink treeId={ownerInfo.ownerTreeId} treeName={ownerInfo.ownerName} treeType={ownerInfo.tfTreeType} />
          </>
        )}
      </>
    )
  }
  return ownerIdResult
}
